/*
  anaar & co. — product gallery arrows

  Dawn's 'thumbnail' desktop layout shows only the .is-active slide and relies
  on the thumbnail strip to switch them — and we've hidden that strip. So we
  take over the arrows at every breakpoint and call media-gallery's own
  setActiveMedia(), which keeps variant switching and the lightbox working
  untouched. (setActiveMedia also scrolls the mobile track into place, so one
  path covers both.) Paging wraps, so both arrows stay live on every slide.

  Two things that are easy to get wrong here:

  1. Do NOT count slides by visibility. On desktop Dawn sets display:none on
     every slide except .is-active, so an offsetParent/visibility test counts
     exactly one slide and concludes there is nothing to page through. Every
     [data-media-id] in the list is a real slide — variant filtering already
     happened in Liquid, so there is nothing to filter out here.

  2. The image is usually narrower than its column (media_size + constrain-height),
     so the arrows are positioned against the active image's box, not the
     column's. Pure CSS can't know that width — it depends on --ratio and the
     viewport — so it is measured.

  Clicks are intercepted on the media-gallery element in the CAPTURE phase.
  slider-component binds its own listener directly to each button during element
  upgrade, which is earlier than this script runs, so stopImmediatePropagation()
  on the button itself would be too late — catching the event on an ancestor
  first is what lets us pre-empt it.
*/
(function () {
  function init(gallery) {
    if (gallery.dataset.anaarArrows === 'ready') return;

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    var buttons = viewer.querySelector('.slider-buttons');
    var list = viewer.querySelector('.product__media-list');
    if (!buttons || !list) return;

    gallery.dataset.anaarArrows = 'ready';

    function slides() {
      return Array.prototype.slice.call(list.querySelectorAll('.product__media-item[data-media-id]'));
    }

    function activeSlide() {
      return list.querySelector('.product__media-item.is-active') || slides()[0];
    }

    // Lay the arrows on the image's own edges, vertically centred on it.
    function position() {
      var active = activeSlide();
      if (!active) return;
      var box = active.querySelector('.product-media-container') || active;
      var a = box.getBoundingClientRect();
      var s = viewer.getBoundingClientRect();
      if (!a.width || !a.height) return;
      buttons.style.left = a.left - s.left + 'px';
      buttons.style.right = s.right - a.right + 'px';
      buttons.style.top = a.top - s.top + a.height / 2 + 'px';
    }

    function sync() {
      buttons.hidden = slides().length < 2; // single-image products get no arrows
      position();
    }

    function step(delta) {
      var items = slides();
      if (items.length < 2) return;
      var i = items.indexOf(activeSlide());
      if (i < 0) i = 0;
      var target = items[(i + delta + items.length) % items.length];
      if (target) gallery.setActiveMedia(target.dataset.mediaId, false);
    }

    gallery.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest && event.target.closest('.slider-button');
        if (!button || !buttons.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        step(button.classList.contains('slider-button--next') ? 1 : -1);
      },
      true
    );

    function undisable() {
      // Dawn disables the buttons at the ends of the track; we wrap instead.
      buttons.querySelectorAll('.slider-button[disabled]').forEach(function (b) {
        b.removeAttribute('disabled');
      });
    }

    new MutationObserver(undisable).observe(buttons, {
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });

    new MutationObserver(sync).observe(list, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    // The image box settles after load and on every resize.
    if (window.ResizeObserver) new ResizeObserver(position).observe(list);
    window.addEventListener('resize', position);
    list.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', position, { once: true });
    });

    undisable();
    sync();
  }

  function initAll(root) {
    (root || document).querySelectorAll('media-gallery').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Quick view and section re-renders inject fresh galleries.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
